module.exports = __webpack_public_path__ + "img/icon-world.319b1b0c.svg";